export const getIsSubApp = (state) => state.global.isSubApp;
export const getIsSocketConnected = (state) => state.global.isSocketConnected;
